/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmTokenDetailRequest = {
    ca: string;
    tokenType?: EvmTokenDetailRequest.tokenType;
    tokenId?: string;
};

export namespace EvmTokenDetailRequest {

    export enum tokenType {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

